import React from "react";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useLang } from "@/context/LangContext";

export default function ReportsPanel({ reports }) {
  const { t } = useLang();
  return (
    <Card className="p-4 border-border/60">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t("ad.col_vendor")}</TableHead>
            <TableHead>{t("ad.col_reason")}</TableHead>
            <TableHead>{t("ad.col_status")}</TableHead>
            <TableHead>{t("ad.col_when")}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {reports.map((r) => (
            <TableRow key={r.report_id}>
              <TableCell className="font-mono text-xs">{r.vendor_id}</TableCell>
              <TableCell>{r.reason}</TableCell>
              <TableCell>{r.status}</TableCell>
              <TableCell>{new Date(r.created_at).toLocaleString()}</TableCell>
            </TableRow>
          ))}
          {reports.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} className="text-center text-muted-foreground">{t("ad.reports_empty")}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
  );
}
